import { render, staticRenderFns } from "./AppWorkspace.html?vue&type=template&id=09440e87&external"
import script from "./AppWorkspace.js?vue&type=script&lang=js&external"
export * from "./AppWorkspace.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AppWorkspace.css?vue&type=custom&index=0&blockType=stryle&issuerPath=%2Fhome%2Frunner%2Fwork%2Fagilis-vuetify%2Fagilis-vuetify%2Fsrc%2Fagilis%2Fcomponents%2FAppWorkspace%2FAppWorkspace.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import VTabs from '@/agilis/wrappers/VTabs/VTabs.vue'
installComponents(component, {VCard,VTab,VTabItem,VTabs})
